import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import parse from 'html-react-parser';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import '../resources/css/magic-content.css';
import { useSetContentMutation } from '../store';
import Env from '../store/env';
import ManagementPanel from './shared/ManagementPanel';

export default function MagicContent({ data }) {

    const serverData = (data && data.content) || { data: '' };
    const [updateData] = useSetContentMutation();

    const [isEditMode, setIsEditMode] = useState(false);
    const [contextData, setContextData] = useState(serverData.data || '');

    const { token } = useSelector((state) => state.environment);
    const parsedText = parse(contextData);

    const handleEdit = () => {
        setIsEditMode(!isEditMode);
    };

    const handleSave = () => {
        setIsEditMode(false);

        const updateContent = {
            ...data,
            content: {
                data: contextData
            }
        };

        updateData(updateContent);
    };

    const handleReset = (e) => {
        setIsEditMode(false);
        setContextData(serverData.data);
    };

    return (
        <div className="container">
            <div className="magic-content-container">

                <ManagementPanel handleEdit={handleEdit} handleSave={handleSave} handleReset={handleReset}></ManagementPanel>

                {isEditMode && <CKEditor
                    config={{
                        removePlugins: ['Title', 'MediaEmbedToolbar', 'Markdown'],
                        toolbar: [
                            'undo',
                            'redo',
                            '|',
                            'heading',
                            '|',
                            'bold',
                            'italic',
                            'underline',
                            'strikethrough',
                            '|',
                            'alignment',
                            'outdent',
                            'indent',
                            '|',
                            'bulletedList',
                            'numberedList',
                            'todoList',
                            '|',
                            'link',
                            'imageInsert',
                            'blockQuote',
                            'insertTable',
                            'mediaEmbed',
                            '|',
                            'fontBackgroundColor',
                            'fontColor',
                            'fontFamily',
                            'subscript',
                            'superscript',
                            'horizontalLine',
                            'specialCharacters',
                            '|',
                            'selectAll',
                            'removeFormat',
                            'findAndReplace',
                            'sourceEditing'
                        ],
                        simpleUpload: {
                            uploadUrl: Env.baseUrl + "/images",
                            headers: {
                                Authorization: `Bearer ${token}`
                            }
                        }
                    }}
                    editor={Editor.Editor}
                    data={contextData}
                    onChange={(_event, editor) => {
                        const editorData = editor.getData();
                        setContextData(editorData);
                    }}
                />}

                {!isEditMode && <div>{parsedText}</div>}
            </div>
        </div>);
}